// Keycloak puts an `impersonator` claim in the tokens it issues while staff impersonate a user.
export function isImpersonationToken(tokenParsed: Record<string, unknown> | undefined): boolean {
  return tokenParsed?.impersonator != null;
}
